<template>
  <b-form @submit.prevent="submit">
    <header-page-layout page-title="Campaigns History">
      <template slot="actions">
        <b-button variant="outline-secondary" @click="back">Back</b-button>
      </template>
      <b-pagination
        :value="currentPage"
        :per-page="pageSize"
        :total-rows="total"
        :hide-goto-end-buttons="true"
        @change="pageChange"
      ></b-pagination>

      <template>
        <b-table class="history-table" striped hover :items="campaignHistory"></b-table>
      </template>
    </header-page-layout>
  </b-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderPageLayout from '../components/HeaderPageLayout'

export default {
  components: {
    HeaderPageLayout
  },

  mounted() {
    if ('id' in this.$route.params) {
      console.log('Recived Campaign ID:' + this.$route.params.id)
      this.fetchCampaignHistory({ id: this.$route.params.id, page: 0 })
    } else {
      console.log('ERR: No Campaign ID')
    }
  },

  computed: {
    ...mapState([
      'campaignHistory'
    ]),

    ...mapState({
      currentPage: 'campaignHistoryPage',
      pageSize: 'campaignHistoryPageSize',
      total: 'campaignHistoryTotal'
    })
  },

  methods: {
    ...mapActions([
      'fetchCampaignHistory'
    ]),

    pageChange(page) {
      this.fetchCampaignHistory({ id: this.$route.params.id, page })
    },

    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.history-table {
  background-color: #ffffff;
}
</style>
